import React from "react";
import './bleed-option.scss'
import {InputField, INPUT_FIELD_TYPE} from "../../../input-field";
import {Dropdown} from "../../../dropdown";
import {ToggleSwitch} from "../../../toggle-switch";
import {DEFAULT_BLEED_UNIT, DEFAULT_BLEED_VALUE, STANDARD_BLEED_VALUE} from "../../../../libraries/download-panel-library";
import {updateBleed} from "../../download-publish-modal-reducer";
import PropTypes from 'prop-types';

/**
 * Responsible for rendering the bleed option in the details section in the download panel
 *
 * @author Ahsan Ejaz <ahsan@250mils.com>
 */
export default class BleedOption extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            bleedValue: DEFAULT_BLEED_VALUE,
            bleedUnits: DEFAULT_BLEED_UNIT,
            showBleed: false
        }
    }

    render() {
        let options = [];
        options.push({
            label: 'cm',
            dataValue: 'cm',
        }, {
            label: 'mm',
            dataValue: 'mm',
        }, {
            label: 'inches',
            dataValue: 'inches',
        })

        return <>
            <div className={'bleed-options ' + (this.state.showBleed ? '' : '_hidden')}>
                <InputField className={'bleed-input'} type={INPUT_FIELD_TYPE.NUMBER} placeholder={'0'} value={this.state.bleedValue} onInputChange={this.#updateBleedValue} inputClassName={'bleed-input-field body-md-regular content-body spacing-p-1'}
                            min={'0'} max={'10'}/>
                <Dropdown
                    dropdownItems={options}
                    dropdownClasses={'-primary -with-border -small'}
                    dropdownItemClasses={"body-sm-regular"}
                    clickHandler={this.#onBleedUnitChange}
                    defaultDataValue={this.state.bleedUnits}
                    title={i18next.t('pmwjs_bleed_units')}
                    portalDomId={'download-panel-dropdown-portal'}
                    aria-label={i18next.t('pmwjs_bleed_units')}
                    dropdownLabelClasses={'body-md-regular'}
                    showDropdownAsModalForMobile={true}
                />
            </div>
            <ToggleSwitch id={'bleed-toggle'} handleToggle={this.#onToggleBleedOption} isChecked={this.state.showBleed} extraClasses={'bleed-toggle -primary'}/>
        </>;
    }

    /**
     *
     * codeReviewAhsan: for the same value, there should be a single source of truth.
     * if you are keeping it in redux, then get the value from redux through connect(), here the value is being set in both redux and local state
     * @param {string} val
     */
    #onBleedUnitChange = (val) => {
        this.setState({
            bleedUnits: val
        })
        PMW.redux.store.dispatch(updateBleed({
            val: this.state.bleedValue,
            units: val
        }))
    }

    /**
     * codeReviewAhsan: for the same value, there should be a single source of truth.
     * if you are keeping it in redux, then get the value from redux through connect(), here the value is being set in both redux and local state
     * @param val
     */
    #updateBleedValue = (val) => {
        this.setState({
            bleedValue: val
        })
        PMW.redux.store.dispatch(updateBleed({
            val: val,
            units: this.state.bleedUnits
        }))
    }

    #onToggleBleedOption = (e) => {
        this.setState({
            showBleed: e.target.checked,
            bleedValue: e.target.checked ? STANDARD_BLEED_VALUE : DEFAULT_BLEED_VALUE,
            bleedUnits: DEFAULT_BLEED_UNIT
        }, function () {
            PMW.redux.store.dispatch(updateBleed({
                val: this.state.bleedValue,
                units: this.state.bleedUnits
            }))
        })
    }
}

BleedOption.propTypes = {
    /**
     * Whether to show bleed inputs or just show the toggle
     */
    showBleed: PropTypes.bool,
    /**
     * Bleed value to use (0 by default)
     */
    bleedValue: PropTypes.string,
    /**
     * Bleed units (mm,cm,in)
     */
    bleedUnits: PropTypes.string
}
